import { PatientGoalType } from 'models/MedicalRecord/MedicalRecordForm.type'

export const SYMPTOMS_IMPACT_LABELS: Record<string, string> = {
  HIGH: 'Alto',
  MEDIUM: 'Médio',
  LOW: 'Baixo',
  NONE: 'Nenhum',
}

export const PATIENT_CONSUMPTION_LABELS: Record<string, string> = {
  ALCOHOL: 'Álcool',
  TOBACCO: 'Tabaco',
  DRUGS: 'Drogas',
  OTHERS: 'Outros',
}

export const PATIENT_GOAL_LABELS: Record<PatientGoalType, string> = {
  [PatientGoalType.ACTION]: 'Ação',
  [PatientGoalType.PRE_CONTEMPLATION]: 'Pré-contemplação',
  [PatientGoalType.CONTEMPLATION]: 'Contemplação',
  [PatientGoalType.PLANNING_OR_PREPARATION]: 'Planejamento ou preparação',
  [PatientGoalType.MAINTENANCE_OR_RELAPSE]: 'Manutenção ou recaída',
}

export const PATIENT_CASE_COMPLEXITY_LABELS: Record<string, string> = {
  NORMAL: 'Nenhum',
  LOW: 'Baixo',
  MODERATE: 'Moderado',
  SERIOUS: 'Grave',
}

export const PATIENT_CASE_COMPLEXITY_COLORS: Record<string, string> = {
  NORMAL: '#4AC326',
  LOW: '#4AC326',
  MODERATE: '#F4A100',
  SERIOUS: '#FF4949',
}

export const MEDICATION_STATUS_LABELS: Record<string, string> = {
  IN_USE: 'Em uso',
  INTERRUPTED: 'Interrompido',
  NOT_APPLICABLE: 'Não se aplica',
}

export const DIAGNOSTIC_STATUS_LABELS: Record<string, string> = {
  REFERRED: 'Referido',
  HYPOTHESIS: 'Hipótese',
  CONFIRMED: 'Confirmado',
  DONE: 'Encerrado',
}

export const NEEDS_TO_CONTINUE_REASON_LABELS: Record<string, string> = {
  CLINICALLY_DISCHARGE: 'Alta por melhora clínica',
  LOST_OF_BENEFIT: 'Perda do benefício',
  REFERRAL: 'Encaminhamento',
  OTHER: 'Outro',
}

export const formatBoolean = (value: boolean | null | undefined): string | null => {
  if (value === null || value === undefined) return null
  return value ? 'Sim' : 'Não'
}
